import SearchType from '../../data/constant/search-type'
import { common, profit } from '../../api/index';
import moment from 'moment';
import DialogType from '../../data/constant/dialog-type';
import HandsontableWrapper from "../../components/table/Handsontable/Handsontable.vue";
const VueSimpleSuggest = require('vue-simple-suggest/dist/cjs');
import 'vue-simple-suggest/dist/styles.css'
export default {
    name: 'ProfitSearch',
    title: '黒修正検索',

    components: {
        HandsontableWrapper,
        VueSimpleSuggest
    },

    data: function () {
        return {
            CENTER: SearchType.CENTER,
            CUSTOMER: SearchType.CUSTOMER,
            REGISTRATION_USER: SearchType.REGISTRATION_USER,
            REGISTERED_CUSTOMER: SearchType.REGISTERED_CUSTOMER,
            MASTER: SearchType.MASTER,
            MAKER: SearchType.MAKER,
            modalId: '',
            isSearchModalVisible: false,
            searchModalVal: {},
            isExportModalVisible: false,
            isDuplicateModalVisible: false,
            footerVal: {
                rightBtnL1: {
                    text: '削除',
                    type: 'danger',
                    isDisabled: true,
                },
                rightBtn: {
                    text: '編集',
                    type: 'success',
                    isDisabled: true,
                },
            },
            table: { data: [] },
            yearMonthList: [],
            patternList: [],
            centerList: [],
            customerList: [],
            makerList: [],
            registrationUserList: [],
            registrationUserName: '',
            form: {
                yearMonth: '',
                registrationUserCd: '',
            },
            searchCondition: {},

            rowCount: 0,
            tableSettings: {
                colHeaders: ['', 'パターン', '発生日', 'メーカー', '支店', 'センター', '得意先', '商品', '建値', '入数',
                    '仕入額', 'ボール', '担当者', '黒修正金額', 'コメント', '登録者', '更新日時'],
                colWidths: [30, 200, 80, 130, 80, 120, 140, 0.1, 0.1, 0.1, 0.1, 0.1, 120, 70, 180, 120, 80],
                cells: this.cells,
                afterChange: this.afterChange,
                manualColumnResize: true,
                manualRowResize: true,
                rowHeaders: true,
                copyPaste: {rowsLimit: 10000,},
            },
            exportSetting: {
                fileType: '1',
                inputFlg: false
            },
            profitAmountTotal: 0,
            isHide: true,
            canSearch: false,
            edit: false,
            retrive: false,
            hiddenCheckBox: [],
            moveFromEdit: this.$route.query.move_from_edit,
            suggestList: [],
            lastInput: "",
        }
    },
    created() {
        this.$store.commit('setLoading', true);
        this.yearMonthList = this.getStorage('lastYearMonthList') || [];
        this.patternList = this.getStorage('profitSearchList') || [];
        var conditionSearch = this.$store.state.conditionSearchProfit || [];
        if(conditionSearch.length > 0){
            this.form.yearMonth = conditionSearch[0].yearMonth;
            this.form.registrationUserCd = conditionSearch[0].registrationUserCd;
            this.registrationUserName = conditionSearch[0].registrationUserName;
            this.form.registerPattern = conditionSearch[0].registerPattern;
            this.makerList = conditionSearch[0].makerList;
            this.centerList = conditionSearch[0].centerList;
            this.customerList = conditionSearch[0].customerList;
            this.registrationUserList = conditionSearch[0].registrationUserList;
        }else{
            this.form.registrationUserCd = this.$store.state.userId;
            this.registrationUserName = this.$store.state.userName;
            this.registrationUserList = [{'cd':this.form.registrationUserCd, 'name': this.registrationUserName}]
            this.form.yearMonth = this.yearMonthList.length > 0 ? this.yearMonthList[0].yearMonthCd : '';
            this.form.registerPattern = this.patternList[0].cd;
        }
        this.$store.commit('setLoading', false);
    },

    mounted() {
        const setting = {
            columns: [
                { data: "editFlg", type: "checkbox", className: "htCenter" },
                { data: "registerPattern", type: "dropdown", className: "htLeft", strict: true, allowInvalid: false, readOnly: true },
                { data: "occurDate", type: "text", className: "text-nowrap", readOnly: true },
                { data: "maker", type: "text", className: "htLeft text-nowrap", readOnly: true, columnSorting: true },
                { data: "department", type: "text", className: "htLeft text-nowrap", readOnly: true },
                { data: "warehouse", type: "text", className: "htLeft text-nowrap", readOnly: true },
                { data: "customer", type: "text", className: "htLeft text-nowrap", readOnly: true },
                { data: "item", type: "text", className: "htLeft text-nowrap", readOnly: true },
                { data: "tatene", type: "numeric", className: "htRight text-nowrap", readOnly: true, numericFormat: { pattern: '0,0.00' } },
                { data: "irisu", type: "numeric", className: "htRight text-nowrap", readOnly: true, numericFormat: { pattern: '0,0' } },
                { data: "purchasePrice", type: "numeric", className: "htRight text-nowrap", readOnly: true, numericFormat: { pattern: '0,0.00' } },
                { data: "bowlNumber", type: "numeric", className: "htRight text-nowrap", readOnly: true, numericFormat: { pattern: '0,0' } },
                { data: "tantoUser", type: "text", className: "htLeft text-nowrap", readOnly: true, columnSorting: true },
                { data: "profitAmount", type: "numeric", className: "htRight text-nowrap", numericFormat: { pattern: '0,0' }, readOnly: true },
                { data: "comment", type: "text", className: "htLeft text-nowrap", readOnly: true },
                { data: "registerUser", type: "text", className: "htLeft text-nowrap", readOnly: true, columnSorting: true },
                { data: "updateDateTime", type: "text", className: "text-nowrap", readOnly: true },
            ]
        };
        this.$refs.myTable.$refs.hotTable.hotInstance.updateSettings(setting, false);
        if(this.moveFromEdit){
            this.search();
        }
    },
    beforeRouteLeave(to, form, next){
        var conditionSearch = {};
        conditionSearch['registerPattern'] = this.form.registerPattern;
        conditionSearch['makerList'] = this.makerList;
        conditionSearch['centerList'] = this.centerList;
        conditionSearch['customerList'] = this.customerList;
        
        conditionSearch['yearMonth'] = this.form.yearMonth;
        conditionSearch['registrationUserCd'] = this.form.registrationUserCd;
        conditionSearch['registrationUserName'] = this.registrationUserName;
        conditionSearch['registrationUserList'] = this.registrationUserList;
        this.$store.commit('setConditionSearchProfit', [JSON.parse(JSON.stringify(conditionSearch))]);
        next();
    },
    methods: {
        // searchSystemUser(value) {
        //     if (!this.canSearch){
        //         this.canSearch = true;
        //         return;
        //     }

        //     const userName = 'registrationUserName';
        //     const userList = 'registrationUserList';
        //     const userCd = 'registrationUserCd';

        //     if (!value) {
        //         this[userName] = '';
        //         this[userList] = [];
        //         return;
        //     }

        //     const request = {
        //         userCd: value,
        //         useName: ''
        //     };
        //     common.systemUser(request)
        //         .then((response) => {
        //             console.log(response);
        //             if (!this.form[userCd]) {
        //                 this[userName] = '';
        //                 this[userList] = [];
        //                 return;
        //             }
        //             this[userName] = response.data.result.userList.length > 0 ?
        //                 response.data.result.userList[0].userName : '';
        //             this[userList] = response.data.result.userList.length > 0 ?
        //                 response.data.result.userList.slice(0, 1).map(value => {
        //                     return {
        //                         cd: value.userCd,
        //                         name: value.userName
        //                     }
        //                 }) : [];

        //             this.$emit('displayErrorMessage', response);
        //         })
        //         .catch((e) => {
        //             console.log('error', e);
        //             this[userName] = '';
        //             this[userList] = [];
        //             this.$emit('displayErrorMessage', e);
        //         });
        // },
        suggestSearch(value) {
            const userName = 'registrationUserName';
            const userList = 'registrationUserList';
            const userCd = 'registrationUserCd';

            if (!value) {
                this[userName] = '';
                this[userList] = [];
                this.$refs.suggest.suggestions = [];
                return;
            }

            this.lastInput = value;

            const request = {
                userCd: value,
                useName: ''
            };
            this.registrationUserList = [];
            this.registrationUserName = "";
            common.systemUser(request)
                .then((response) => {
                    if (!this.form[userCd]) {
                        this[userName] = '';
                        this[userList] = [];
                        this.$refs.suggest.suggestions = [];
                        return;
                    }
                    if(this.lastInput == request.userCd){
                        this.suggestList = response.data.result.userList.map(value => { return { cd: value.userCd, name: value.userName } });
                        this.$refs.suggest.suggestions = response.data.result.userList.map(value => value.userCd);
                        this.$refs.suggest.input.click();
                    }
                })
                .catch((e) => {
                    console.log('error', e);
                });
        },
        selectSuggest() {
            this.form.registrationUserCd = this.$refs.suggest.selected;
            var name = this.suggestList.filter(value =>
                value.cd === this.$refs.suggest.selected)
            this.registrationUserName = name[0].name;
            this['registrationUserList'] = this.suggestList.length > 0 ? this.suggestList.filter(value =>
                value.cd === this.$refs.suggest.selected).map(value => {
                return {
                    cd: value.cd,
                    name: value.name
                }
            }) : [];
        },
        onblur(value1){
            var name = this.suggestList.filter(value =>
                value.cd === value1)
            this.registrationUserName = name.length == 0 ? "" : name[0].name
            this['registrationUserList'] = name.length > 0 ? this.suggestList.filter(value =>
                value.cd === value1).map(value => {
                return {
                    cd: value.cd,
                    name: value.name
                }
            }) : [];
        },
        /**
         * 検索モーダル表示
         * */
        showSearchModal(modalId, isSingle) {

            this.modalId = modalId;

            this.searchModalVal.modalId = modalId;
            this.searchModalVal.isSingle = isSingle;
            switch (modalId) {
                case SearchType.REGISTRATION_USER:
                    this.searchModalVal.selectedItemList = this.registrationUserList;
                    break;
                case SearchType.MAKER:
                    this.searchModalVal.selectedItemList = this.makerList;
                    break;
                case SearchType.CENTER:
                    this.searchModalVal.selectedItemList = this.centerList;
                    break;
                case SearchType.CUSTOMER:
                    this.searchModalVal.selectedItemList = this.customerList;
                    break;
            }
            //検索モーダル表示
            this.isSearchModalVisible = true;
        },

        /**
         * マスタ検索モーダル表示
         * 
         */
         showMasterSearchModal(modalId, type, isSingle) {
            this.modalId = modalId;
            this.searchModalVal.type = type;
            this.searchModalVal.modalId = modalId;
            this.searchModalVal.isSingle = isSingle;

            switch (type) {
                /*             
                case SearchType.CENTER:
                    this.searchModalVal.selectedItemList = this.centerList;
                    break;
                */
                case SearchType.REGISTERED_CUSTOMER:
                    this.searchModalVal.selectedItemList = this.customerList;
                    break;
                case SearchType.TANTO:
                    this.searchModalVal.selectedItemList = this.userList;
                    break;
                /*
                case SearchType.MAKER:
                    this.searchModalVal.selectedItemList = this.makerList;
                    break;
                case SearchType.REGISTRATION_USER:
                    this.searchModalVal.selectedItemList = this.registrationUserList;
                    break;
                */
            }

            //検索モーダル表示
            this.isSearchModalVisible = true;
        },

        /**
         * 検索
         * */
        search() {
            this.form.registerPattern = this.form.registerPattern ? parseInt(this.form.registerPattern) : this.form.registerPattern;
            // this.form.registrationUserCd = this.registrationUserList.map(value => {
            //     const cdList = value.cd.split('-');
            //     return cdList[0]
            // });

            this.form.makerCd = this.makerList.map(value => {
                const cdList = value.cd.split('-');
                return cdList[0]
            });
            this.form.centerList = this.centerList.map(value => {
                const cdList = value.cd.split('-');
                return {
                    departmentCd: cdList[0],
                    centerCd: cdList[1]
                }
            });

            this.form.customerList = this.customerList.map(value => {
                var cd = value.cd;
                return {
                    customerHeadCd: cd.substring(0,5),
                    customerBranchCd: cd.substring(5,8)
                }
            });
            this.$store.commit('setLoading', true);
            var self = this;
            self.profitAmountTotal = 0;
            profit.search(this.form)
                .then((response) => {
                    console.log(response);
                    var rs = response.data.result.responseList;
                    self.hiddenCheckBox = [];
                    for (let i = 0; i < response.data.result.responseList.length; i++) {
                        const element = response.data.result.responseList[i];
                        if (self.patternList.length > 0) {
                            self.patternList.forEach(value =>{
                                if (value.cd == element.registerPattern) {
                                    rs[i].registerPattern = value.name;
                                }
                            });
                        }
                        rs[i].maker = element.makerCd && element.makerName ? element.makerCd + ':' + element.makerName : '';
                        rs[i].department = element.departmentCd && element.departmentName ? element.departmentCd + ':' + element.departmentName : '';
                        rs[i].warehouse = element.warehouseCd && element.warehouseName ? element.warehouseCd + ':' + element.warehouseName : '';
                        rs[i].customer = element.customerCd && element.customerName ? element.customerCd + ':' + element.customerName : '';
                        rs[i].item = element.itemCd && element.itemName ? element.itemCd + ':' + element.itemName : '';
                        rs[i].tantoUser = element.tantoUserCd && element.tantoUserName ? element.tantoUserCd + ':' + element.tantoUserName : '';
                        rs[i].registerUser = element.registerUserName ? element.registerUserName : '';
                        rs[i].occurDate = element.occurDate ? moment(element.occurDate).format('YYYY/MM/DD') : '';
                        self.profitAmountTotal += rs[i].profitAmount ? rs[i].profitAmount : 0;
                        if(!rs[i].editFlg){
                            rs[i].editFlg = null;
                        }
                        self.hiddenCheckBox.push(rs[i].editFlg);
                    }
                    self.profitAmountTotal = new Intl.NumberFormat().format(self.profitAmountTotal);
                    self.$refs.myTable.$refs.hotTable.hotInstance.loadData(rs || []);
                    self.rowCount = self.$refs.myTable.$refs.hotTable.hotInstance.countRows();
                    let disableFlg = false;
                    for(let j = 0; j < self.hiddenCheckBox.length; j++){
                        if(!self.hiddenCheckBox[j]){
                            self.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'className', 'htCenter hidden');
                            self.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'readOnly', true);
                            self.$refs.myTable.$refs.hotTable.hotInstance.render();
                        }
                        if (disableFlg) {
                            continue;
                        }
                        if (self.hiddenCheckBox[j]) {
                            disableFlg = true;
                        }
                    }
                    if (disableFlg) {
                        self.footerVal.rightBtn.isDisabled = false;
                        self.footerVal.rightBtnL1.isDisabled = false;
                    } else {
                        self.footerVal.rightBtn.isDisabled = true;
                        self.footerVal.rightBtnL1.isDisabled = true;
                    }
                    self.$emit('displayErrorMessage', response);
                    self.$store.commit('setLoading', false);
                })
                .catch((e) => {
                    console.log('error', e);
                    this.rowCount = 0;
                    this.registerTypeList = [];
                    this.fileList = [];
                    this.$refs.myTable.$refs.hotTable.hotInstance.loadData([]);
                    this.$emit('displayErrorMessage', e);
                    this.$store.commit('setLoading', false);
                });
        },

        selectAll() {
            this.$store.commit('setLoading', true);
            var data = this.$refs.myTable.$refs.hotTable.hotInstance.getSourceData();
            for (var i in data) {
                if(data[i].editFlg == false){
                    this.footerVal.rightBtn.isDisabled = false;
                    this.footerVal.rightBtnL1.isDisabled = false;
                    data[i].editFlg = true;
                }
            }
            this.$refs.myTable.$refs.hotTable.hotInstance.loadData(data);
            for(let j = 0; j < this.hiddenCheckBox.length; j++){
                if(!this.hiddenCheckBox[j]){
                    this.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'className', 'htCenter hidden');
                    this.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'readOnly', true);
                    this.$refs.myTable.$refs.hotTable.hotInstance.render();
                }
            }
            this.$store.commit('setLoading', false);
        },

        deSelectAll() {
            this.$store.commit('setLoading', true);
            this.footerVal.rightBtn.isDisabled = true;
            this.footerVal.rightBtnL1.isDisabled = true;
            var data = this.$refs.myTable.$refs.hotTable.hotInstance.getSourceData();
            for (var i in data) {
                if(data[i].editFlg == true)
                data[i].editFlg = false;
            }
            this.$refs.myTable.$refs.hotTable.hotInstance.loadData(data);
            for(let j = 0; j < this.hiddenCheckBox.length; j++){
                if(!this.hiddenCheckBox[j]){
                    this.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'className', 'htCenter hidden');
                    this.$refs.myTable.$refs.hotTable.hotInstance.setCellMeta(j,0,'readOnly', true);
                    this.$refs.myTable.$refs.hotTable.hotInstance.render();
                }
            }
            this.$store.commit('setLoading', false);
        },

        /**
         * 隠しボタンを処理する
         * @param {*} changes 
        */
        afterChange: function (changes) {
            if (changes) {
                const hot = this.$refs.myTable.$refs.hotTable.hotInstance;
                // let r = changes[0][0]; //row index
                let c = hot.propToCol(changes[0][1]); //col index

                const data = hot.getSourceData();
                if (c === 0 && data.find(value => value.editFlg === true)) {
                    this.footerVal.rightBtn.isDisabled = false;
                    this.footerVal.rightBtnL1.isDisabled = false;
                } else {
                    this.footerVal.rightBtn.isDisabled = true;
                    this.footerVal.rightBtnL1.isDisabled = true;
                }
            }
        },

        /**
         * 検索条件追加
         * @param val
         * */
        addItem(val) {
            this.canSearch = false;
            switch (this.modalId) {
                case SearchType.CENTER:
                    this.centerList = val;
                    break;
                case SearchType.CUSTOMER:
                    this.customerList = val;
                    break;
                case SearchType.MAKER:
                    this.makerList = val;
                    break;
                case SearchType.REGISTRATION_USER:
                    this.registrationUserList = val;
                    this.form.registrationUserCd = this.registrationUserList.length > 0 ? this.registrationUserList[0].cd : '';
                    this.registrationUserName = this.registrationUserList.length > 0 ? this.registrationUserList[0].name : '';
                    break;
                case SearchType.MASTER:
                    switch(this.searchModalVal.type){
                        case SearchType.REGISTERED_CUSTOMER:
                            this.customerList = val;
                            break;
                    }
                    break;
            }
            this.suggestList = val;
            this.$nextTick(() => this.canSearch = true);
        },

        /**
         * 検索条件クリア
         * @param value
         * */
        clear(value) {
            switch (value) {
                case SearchType.REGISTRATION_USER:
                    this.registrationUserList = [];
                    break;
                case SearchType.MAKER:
                    this.makerList = [];
                    break;
                case SearchType.CENTER:
                    this.centerList = [];
                    break;
                case SearchType.REGISTERED_CUSTOMER:
                    this.customerList = [];
                    break;
            }

            if (value) return;

            this.form.yearMonth = this.yearMonthList.length > 0 ? this.yearMonthList[0].yearMonthCd : '';
            this.form.registerPattern = this.patternList.length > 0 ? this.patternList[0].cd : '';
            this.form.registrationUserCd = this.$store.state.userId || '';
            this.registrationUserName = this.$store.state.userName || '';
            this.registrationUserList = [{ 'cd': this.form.registrationUserCd, 'name': this.registrationUserName }];
            this.makerList = [];
            this.centerList = [];
            this.customerList = [];
        },
        moveEdit() {
            const data = this.$refs.myTable.$refs.hotTable.hotInstance.getSourceData();
            const profitIdList = data.filter(value =>
                value.editFlg === true).map(value => {
                    return parseInt(value.profitId, 10)
                });
            this.edit = true;
            this.$store.commit('setProfitIdList', profitIdList);

            this.$router.push({ path: '/profit_regist', query: { move_from_search: true }})
        },
        delRow() {
            this.$store.commit('setLoading', true);
            const data = this.$refs.myTable.$refs.hotTable.hotInstance.getSourceData();
            const profitIdList = data.filter(value =>
                value.editFlg === true).map(value => {
                    return parseInt(value.profitId,10)
                });
            if(profitIdList.length != 0){
                this.$emit('showConfirmModal', {
                    type: DialogType.INFO,
                    title: '確認',
                    message: '選択された黒修正を削除します。よろしいですか？',
                    confirm: () => { 
                        const request = {
                            profitId: profitIdList
                        };
                        this.$store.commit('setLoading', true);
                        profit.delete(request)
                            .then((response) => {
                                this.$store.commit('setLoading', false);
                                if(response.data.statusCd == 0){
                                    this.$emit('showSimpleModal', {
                                        type: DialogType.SUCCESS,
                                        title: '確認',
                                        message: response.data.message,
                                        closeFunc: () => { this.search() } 
                                    });
                                }
                            })
                            .catch((e) => {
                                console.log('error', e);
                                this.$emit('displayErrorMessage', e);
                                this.$store.commit('setLoading', false);
                            });
                    }
                });
            }
            this.$store.commit('setLoading', false);
        },
        cells(row, cols, prop) {
            switch (prop) {
                case 'registerPattern':
                    {
                        const cellProperties = {};
                        cellProperties.source = this.patternList.map(value => value.name);
                        return cellProperties;
                    }
            }
        },
        hideColumns() {
            this.$store.commit('setLoading', true);
            if (!this.isHide) {
                this.$refs.myTable.$refs.hotTable.hotInstance.updateSettings({
                    colWidths: [30, 200, 80, 130, 80, 120, 140, 0.1, 0.1, 0.1, 0.1, 0.1, 120, 70, 180, 120, 80]
                });

                this.isHide = true;
            }

            this.$store.commit('setLoading', false);
        },
        showColumns() {
            this.$store.commit('setLoading', true);
            if (this.isHide) {
                this.$refs.myTable.$refs.hotTable.hotInstance.updateSettings({
                    colWidths: [30, 200, 80, 130, 80, 120, 140, 200, 65, 65, 65, 65, 120, 70, 180, 120, 80]
                });

                this.isHide = false;
            }

            this.$store.commit('setLoading', false);
        },
    },
}
